import React from "react";
import * as Icon from "react-bootstrap-icons";
import { motion } from "framer-motion";
import { getPostDate } from "../utils/date";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

const BannerNewsItem = ({ post, type = "none" }) => {
  const lang = useSelector((state) => state.mainSlice.lang);
  const chars = type === "posts" ? 300 : 70;
  const item = {
    visible: { opacity: 1, y: 0 },
    hidden: { opacity: 0, y: 50 },
  };
  return (
    <motion.div
      variants={item}
      transition={{ duration: 0.5 }}
      className="w-100 banner-news-item"
    >
      <Link
        to={
          post.type === "article"
            ? `/article/${post.slug}`
            : `/post/${post.slug}`
        }
      >
        <p className="news-title-one two">
          <span
            className="underline-animation-on-hover"
            style={type === "posts" ? { fontSize: "18px" } : {}}
          >
            {type === "posts" && post.category !== null ? (
              <span
                className={`posts-name-category ${
                  post.category.slug === "gullugyn-habarlary"
                    ? "gulluk"
                    : post.category.slug === "beyleki-habarlar"
                    ? "beyleki"
                    : "green"
                }`}
              >
                {lang === "en"
                  ? post.category.name_en
                  : lang === "ru"
                  ? post.category.name_ru
                  : post.category.name_tm}
              </span>
            ) : (
              ""
            )}
            {lang === "en"
              ? post.name_en
              : lang === "ru"
              ? post.name_ru
              : post.name_tm}
            {/* {lang === "en"
              ? post.name_en.substring(0, chars)
              : lang === "ru"
              ? post.name_ru.substring(0, chars)
              : post.name_tm.substring(0, chars)}{" "} */}
            {/* {lang === "en"
              ? post.name_en.length > chars
                ? "..."
                : ""
              : lang === "ru"
              ? post.name_ru.length > chars
                ? "..."
                : ""
              : post.name_tm.length > chars
              ? "..."
              : ""} */}
          </span>
        </p>
        <p className="news-date">
          {getPostDate(post.pub_date)} &nbsp; <Icon.Eye /> {post.views}
        </p>
        {type === "posts" ? (
          lang === "en" ? (
            <p className="news-short-content">{post.short_content_en}</p>
          ) : lang === "ru" ? (
            <p className="news-short-content">{post.short_content_ru}</p>
          ) : (
            <p className="news-short-content">{post.short_content_tm}</p>
          )
        ) : (
          ""
        )}
      </Link>
    </motion.div>
  );
};

export default BannerNewsItem;
